import { useAuthStore } from '@/stores';
import {apiHost} from "@/config";

const baseUrl = apiHost;

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE')
};

function request(method) {
    return (path, body) => {
        const url = path.startsWith(apiHost) ? path : apiHost + path;
        const requestOptions = {
            method,
            headers: authHeader(url)
        };
        if (body) {
            requestOptions.headers['Content-Type'] = 'application/json';
            requestOptions.body = JSON.stringify(body);
        }
        return fetch(url, requestOptions).then(handleResponse);
    }
}

// helper functions

function authHeader(url) {
    // return auth header with jwt if user is logged in and request is to the api url
    const { token } = useAuthStore();
    const isLoggedIn = !!token;
    const isApiUrl = url.startsWith(baseUrl);
    if (isLoggedIn && isApiUrl) {
        return { Authorization: `Bearer ${token}`, Accept: 'application/json' };
    } else {
        return {
            Accept: 'application/json',
        };
    }
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        if (!response.ok) {
            const { user, logout } = useAuthStore();
            if ([401, 403].includes(response.status) && user) {
                // first try to refresh the token
                const authStore = useAuthStore();
                if(authStore.refreshTried){
                    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                    logout();
                }
                else {
                    authStore.refreshToken();
                }


            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}